import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/services/security/auth.guard';
import { FormAgenciaComponent } from './formagencia';
import { FormConceitoPessoaComponent } from '../../pessoa/forms/formconceitopessoa';
import { FormDepartamentoComponent } from './formdepartamento';
import { FormFormaEnvioComponent } from './formformaenvio';
import { FormFuncaoComponent } from './formfuncao';
import { FormVeiculoComponent } from './formveiculo';
import { FormModeloEtiquetaComponent } from './formmodeloetiqueta';
import { FormSuporteTecnicoComponent } from './formsuportetecnico';
import { FormPessoaCatalogoComponent } from './formpessoacatalogo';
import { FormAerodromoComponent } from './formaerodromo';



@NgModule({
    imports: [RouterModule.forChild([
        { path: 'formagencia', component: FormAgenciaComponent, canActivate: [AuthGuard] },
        { path: 'formconceitopessoa', component: FormConceitoPessoaComponent, canActivate: [AuthGuard] },
        { path: 'formdepartamento', component: FormDepartamentoComponent, canActivate: [AuthGuard] },
        { path: 'formformaenvio', component: FormFormaEnvioComponent, canActivate: [AuthGuard] },
        { path: 'formfuncao', component: FormFuncaoComponent, canActivate: [AuthGuard] },
        { path: 'formveiculo', component: FormVeiculoComponent, canActivate: [AuthGuard] },
        { path: 'formmodeloetiqueta', component: FormModeloEtiquetaComponent, canActivate: [AuthGuard] },
        { path: 'formsuportetecnico', component: FormSuporteTecnicoComponent, canActivate: [AuthGuard] },
        { path: 'formpessoacatalogo', component: FormPessoaCatalogoComponent, canActivate: [AuthGuard] },
        { path: 'formaerodromo', component: FormAerodromoComponent, canActivate: [AuthGuard] },
    ])],
    exports: [RouterModule]
})
export class GeralFormRoutingModule { }
